import { handleActions } from "redux-actions";

import { CLUSTER, SEGMENTS, SELECTED_COUNTRIES } from "./types";

const initState = {
  cluster: null,
  segments: [],
  selectedCountries: [],
};

export default handleActions(
  {
    [CLUSTER]: (state, { payload }) => {
      return { ...state, cluster: payload };
    },
    [SEGMENTS]: (state, { payload }) => {
      return { ...state, segments: payload };
    },
    [SELECTED_COUNTRIES]: (state, { payload }) => {
      return { ...state, selectedCountries: payload };
    },
  },
  initState
);
